import { IRecycleBinViewDTO } from 'business/models/Models';
import ETreeNodeTypes from 'enums/ETreeNodeTypes';

const containerNodeTypes = [
  ETreeNodeTypes.Project,
  ETreeNodeTypes.ProjectFolder,
  ETreeNodeTypes.ProjectsFolder,
  ETreeNodeTypes.Projects,
  ETreeNodeTypes.Screens,
  ETreeNodeTypes.ScreensFolder,
  ETreeNodeTypes.QuickAccess,
  ETreeNodeTypes.CrystalTrackv4,
  ETreeNodeTypes.SynchrotronTripv4Folder,
  ETreeNodeTypes.SearchesFolder,
];

export { containerNodeTypes };

export enum EExplorerNodesView {
  Screen = 'Screen',
  Experiment = 'Experiment',
  Seed = 'Seed',
  ProteinFormulation = 'ProteinFormulation',
  SynchrotronTripv4 = 'SynchrotronTripv4',
  SearchAnalysis = 'SearchAnalysis',
  FragmentScreen = 'FragmentScreen',
  TextSearch = 'TextSearch',
}

export const explorerNodesPaths = {
  [EExplorerNodesView.Screen]: 'screen',
  [EExplorerNodesView.Experiment]: 'exp',
  [EExplorerNodesView.SynchrotronTripv4]: 'synchrotrontrip',
  [EExplorerNodesView.SearchAnalysis]: 'snf',
  [EExplorerNodesView.FragmentScreen]: 'fragment',
  [EExplorerNodesView.TextSearch]: 'search',
};

export type TreeNodeDetail = {
  treeNodeId: number;
  name: string;
  type: ETreeNodeTypes;
  entityId: number;
  extra?: any;
};

export interface RecycleBinTableView extends Omit<IRecycleBinViewDTO, 'name'> {
  name: React.JSX.Element | string;
}

export const AllowProjectParentNodes = [
  ETreeNodeTypes.Project,
  ETreeNodeTypes.ProjectFolder,
  ETreeNodeTypes.CrystalTrackv4,
  ETreeNodeTypes.SynchrotronTripv4Folder,
  ETreeNodeTypes.Searches,
  ETreeNodeTypes.SearchesFolder,
];

export const AllowedNodeTypesForSendToMarco = [
  ETreeNodeTypes.Project,
  ETreeNodeTypes.ProjectFolder,
  ETreeNodeTypes.ProjectsFolder,
];

export const allowedTargetsMap = {
  [ETreeNodeTypes.ScreensFolder]: [ETreeNodeTypes.ScreensFolder, ETreeNodeTypes.Screens],
  [ETreeNodeTypes.Screen]: [
    ETreeNodeTypes.Project,
    ETreeNodeTypes.ScreensFolder,
    ETreeNodeTypes.ProjectFolder,
    ETreeNodeTypes.Screens,
  ],
  [ETreeNodeTypes.FragmentScreen]: [ETreeNodeTypes.Project, ETreeNodeTypes.ProjectFolder],
  [ETreeNodeTypes.Experiment]: [ETreeNodeTypes.Project, ETreeNodeTypes.ProjectFolder],
  [ETreeNodeTypes.Protein]: [ETreeNodeTypes.Project, ETreeNodeTypes.ProjectFolder],
  [ETreeNodeTypes.Seed]: [ETreeNodeTypes.ProjectFolder],
  [ETreeNodeTypes.SearchAnalysis]: [
    ETreeNodeTypes.Searches,
    ETreeNodeTypes.SearchesFolder,
    ETreeNodeTypes.Project,
    ETreeNodeTypes.ProjectFolder,
    ETreeNodeTypes.ProjectsFolder,
  ],
  [ETreeNodeTypes.SearchesFolder]: [
    ETreeNodeTypes.Searches,
    ETreeNodeTypes.SearchesFolder,
  ],
  [ETreeNodeTypes.SynchrotronTripv4]: [
    ETreeNodeTypes.SynchrotronTripv4Folder,
    ETreeNodeTypes.CrystalTrackv4,
  ],
  [ETreeNodeTypes.SynchrotronTripv4Folder]: [
    ETreeNodeTypes.SynchrotronTripv4Folder,
    ETreeNodeTypes.CrystalTrackv4,
  ],
  [ETreeNodeTypes.Project]: [ETreeNodeTypes.ProjectsFolder],
  [ETreeNodeTypes.ProjectFolder]: [ETreeNodeTypes.ProjectFolder, ETreeNodeTypes.Project],
  [ETreeNodeTypes.ProjectsFolder]: [ETreeNodeTypes.ProjectsFolder],
} as { [key: string]: ETreeNodeTypes[] };
